/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetMonthlyEnergyStatsPathParameters } from 'api/actions/get-monthly-energy-stats/get-monthly-energy-stats-path-parameters';
import { GetMonthlyEnergyStatsResponse } from 'api/actions/get-monthly-energy-stats/get-monthly-energy-stats-response';

type GetMonthlyEnergyStatsQueryParameters = Record<string, any>;

/**
 * The path of the GetMonthlyEnergyStats action.
 */
export const getMonthlyEnergyStatsActionPath = new SweetPath<keyof GetMonthlyEnergyStatsPathParameters>(
  '/tuya-device/monthly-energy-stats/{deviceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetMonthlyEnergyStats actions.
 */
export default function createGetMonthlyEnergyStatsAction(axios: AxiosInstance) {
  return function getMonthlyEnergyStatsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetMonthlyEnergyStatsPathParameters;
    query?: GetMonthlyEnergyStatsQueryParameters;
  }) {
    const path = getMonthlyEnergyStatsActionPath.insert(parameters);

    return axios.get<GetMonthlyEnergyStatsResponse, GetMonthlyEnergyStatsResponse>(path, { params: query, headers });
  };
}
